import type { FaireProductEntity } from "../../entity_types/product";

export const p_kdrhy6cpqq: FaireProductEntity = {
  token: "p_kdrhy6cpqq",
  type: "product",
  name: "Street Side RING (New Design)",
  brandToken: "b_azjmuj2qt2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d3fd230b487e069071fb01bd92a010d39c6d16f99af28becbac3f82d92005658.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b6e3c542f69ab904e6c848aa78a5d217e86cfc29d511a980f43fabd5eb58dca.jpeg",
    "https://cdn.faire.com/fastly/6f1cdb3236502a7b1970acd42145a06f6788b50b3bbd2fb4803284bf9c4978b7.jpeg",
    "https://cdn.faire.com/fastly/89d8443d27a5eb30c8016ac23098add245dc21a1c18eb0650eaedef7ce73e2af.jpeg",
    "https://cdn.faire.com/fastly/0c3b04636916dda0835f8b59f19668cb641a88b56553a1b2ed584f2cd1132850.jpeg",
    "https://cdn.faire.com/fastly/a576b3cee92c7a0f545bd361ea775496c9d3e8b60e62719d2b97be55e0a0c417.jpeg",
    "https://cdn.faire.com/fastly/3b499f6e2d9b5066b9adeb4d1247eedb78b45d348eb84937398ab68acc33dd0f.jpeg",
    "https://cdn.faire.com/fastly/7d69b2c62598de8ac9de2b9dc8836f4523beddc941544e3ae6ddd108d1d66fd4.jpeg",
    "https://cdn.faire.com/fastly/aadc4abece2d1073e681e9e8b54b3fff33d35151c9d2e5b9d10dd37235dd5fca.jpeg",
    "https://cdn.faire.com/fastly/53cb4bee65dbfb76b4cabb0cc9eb4f043f36cd388b09307736040356f958b0bf.jpeg",
    "https://cdn.faire.com/fastly/a0fa5e4c6e57374b9c01f5963c6dca5e1930e65edb9804c7cdc3e4fa6c0c24cf.jpeg",
    "https://cdn.faire.com/fastly/dda3f28dba0d35c9b71028bbe3a07947886b2a59df207c4f03959b297785ce5e.jpeg",
    "https://cdn.faire.com/fastly/593d945a77212e100adb49c1831f6a7d0eceffe99ce6fe33b0e7cae46b1facb0.jpeg",
    "https://cdn.faire.com/fastly/c84528df0c8a8e9cbaa9ae84ee6c123f9edb642962fd32ea11e2d97b6dc7699e.jpeg",
    "https://cdn.faire.com/fastly/2090e303deaba951d583bf91be7f1690f4e87d601d9554ad267a3a58fc0a704e.jpeg",
    "https://cdn.faire.com/fastly/79b68508d75e47768b0dda078c6dd2d2247bc80634c1a9bfb59bce23695d5620.jpeg",
    "https://cdn.faire.com/fastly/7287dbfa2de2e7314aa3a9b38423d058a038c5c4d216cffefe65a567ddadb20e.jpeg",
  ],
  priceDollars: 25.12,
  description:
    "Say hello to your new favorite ring! This ring is one of our favorite items from the stainless steel collection. You will steal the show with this beauty and your ring stash will be on point. Are you ready to shine with this on-trend item? Tip: this ring also makes a great Valentine's Day gift! Hurry and shop!\n\n * Made of premium Stainless Steel, so won't discolor! \n * This ring comes in different sizes ",
  tags: [],
  msrpDollars: 50.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:58.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
